<ul class="nav nav-underline">
  @for (tab of tabs; track tab) {
    @if (tab.disabled) {
      <li class="nav-item">
        <a class="nav-link disabled">{{ tab.text }}</a>
      </li>
    }
    @if (!tab.disabled) {
      <li class="nav-item">
        <ng-container
          *ngTemplateOutlet="
            tab.routerLink ? anchorRouter : anchorUrl;
            context: { $implicit: tab }
          ">
        </ng-container>
      </li>
    }
  }
</ul>

<ng-template #anchorRouter let-tab>
  <a
    class="nav-link"
    [class.active]="tab.text === selected"
    [attr.aria-current]="tab.text === selected ? 'page' : undefined"
    [routerLink]="tab.routerLink"
    [queryParams]="tab.queryParams"
    [fragment]="tab.fragment"
    (click)="onClick(tab.text, true)"
    >{{ tab.text }}</a
  >
</ng-template>

<ng-template #anchorUrl let-tab>
  <a
    class="nav-link"
    [class.active]="tab.text === selected"
    [attr.aria-current]="tab.text === selected ? 'page' : undefined"
    [href]="tab.url ?? '#'"
    (click)="onClick(tab.text, !!tab.url)"
    >{{ tab.text }}</a
  >
</ng-template>
